var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatMessage typeInit"},[_c('div',{staticClass:"msgBox"},[_c('p',{staticClass:"messageText initText"},[_vm._v(" "+_vm._s(_vm.messageData.message)+" ")])]),_c('span',{staticClass:"chatBubble"}),_c('span',[_c('p',{staticClass:"timeStamp"},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.messageData.created_at))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }